import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput } from '@bos/ui';
import { useController } from 'react-hook-form';
export const TextField = ({ control, name, registerOptions, ...appTextInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const controlledValue = field.value ?? '';
    const error = appTextInputProps.error ?? fieldState.error?.message;
    return (_jsx(TextInput, { ...field, ...appTextInputProps, error: error, value: controlledValue }));
};
